import axios from 'axios'
import request from '@/utils/request'
import { getToken } from '@/utils/auth'

export function getPartnerList(data) {
  return request({ url: '/admin/partner/list', method: 'post', data })
}

export function getPartnerDetail(data) {
  return request({ url: '/admin/partner/detail', method: 'post', data })
}

export function updatePartner(data) {
  return request({ url: '/admin/partner/update', method: 'post', data })
}

export function getPartnerMemberList(data) {
  return request({ url: '/admin/partner/memberList', method: 'post', data })
}

export function getPartnerOrderContactList(data) {
  return request({ url: '/admin/partner/orderContactList', method: 'post', data })
}

export function uploadPartnerImage(file) {
  const formData = new FormData()
  formData.append('image', file)
  return axios.post(process.env.VUE_APP_BASE_API + '/admin/product/uploadImage', formData, {
    headers: {
      Authorization: 'Bearer ' + getToken(),
      'Content-Type': 'multipart/form-data'
    }
  }).then(res => {
    if (res.data.code !== 0) throw new Error(res.data.message || '上传失败')
    return res.data
  })
}
